/** @jsx jsx */
import { jsx } from '@emotion/core';
import { get, castArray } from 'lodash';

import ValidationChecks from 'app/developer-v3/components/ValidationChecks';
import LifecycleErrorItem from 'app/developer-v3/pages/versions/LifecycleErrorItem';

import type { ValidationResultSetWrapper } from 'app/developer-v3/types';

export const getServerErrorBlock = (
  requestFailed: boolean,
  errors: string | Array<string> | ValidationResultSetWrapper
) => {
  if (!requestFailed) return null;

  return typeof errors === 'object' && get(errors, ['results']) ? (
    <ValidationChecks errors={get(errors, ['results'], [])} />
  ) : (
    <ul>
      {castArray(errors).map((error, i, all) => (
        <LifecycleErrorItem
          error={error}
          index={i}
          key={i}
          totalErrors={all.length}
        />
      ))}
    </ul>
  );
};
